<template>
  <div>
    <b-jumbotron header="Art 3.0" :lead="leadLine" >
      <div v-if="account !== null">
        <b-btn v-b-modal.modal1 variant="primary" href="#">Buy now</b-btn>
      </div>
      <div v-else>
        <p>To buy Art 3.0, please log in to your Ethereum account in your DApp enabled browser.
          We recommend using the browser plugin <a href="https://www.metamask.io">Metamask</a>.</p>
      </div>
    </b-jumbotron>

    <div>
      <b-modal ref="buyArtModalRef" id="modal1" hide-footer title="Buy Art 3.0">

        <b-form class="on-the-left" @submit="onSubmit">

          <b-form-group id="displayNameGroup"
              label="Display name:"
              label-for="displayName"
              description="The name will be publicly displayed next to your purchase. You can use a pseudonym if you choose.">
            <b-form-input id="displayName"
                  required
                  type="text"
                  placeholder="Display Name"
                  v-model="displayName">
            </b-form-input>
          </b-form-group>

          <b-form-group id="emailGroup"
              label="Email address:"
              label-for="email"
              description="">
            <b-form-input id="email"
                  type="email"
                  required
                  placeholder="you@email.com"
                  v-model="email">
            </b-form-input>
          </b-form-group>

          <b-form-group id="phoneGroup"
              label="Phone number:"
              label-for="phoneNumber"
              description="Your contact information will only be used to contact you to organize shipping to and from you. See FAQ for information about shipping and ownership of Art 3.0.">
            <b-form-input id="phoneNumber"
                  type="tel"
                  required
                  placeholder="01234 567890"
                  v-model="phoneNumber">
            </b-form-input>
          </b-form-group>

          <b-form-group id="confirmConditionsGroup"
              label="I agree to the terms and conditions of ownership of Art 3.0. See FAQ for more details:"
              label-for="confirmConditions"
              description="">
            <b-form-checkbox id="confirmConditions"
                  required
                  v-model="confirmConditions">
            </b-form-checkbox>
          </b-form-group>

          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
      </b-modal>
    </div>          

    
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import Web3 from 'web3'
import {PUBLIC_KEY} from '../config';

export default {
  name: 'buy-art',
  components: {
    'nav-bar': NavBar
  },
  data () {
    return {
      web3: null,
      web3Provider: null,
      price: 0,
      priceEth: 0,
      leadLine: "",
      contracts: {},
      account: null,
      displayName: null,
      //contactData: null,
      email: null,
      phoneNumber: null,
      confirmConditions: false
    }
  },
  mounted () {
    this.getProvider()
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault();
      this.buyArt();
    },
    buyArt() {
      var buyArtModal = this.$refs.buyArtModalRef;
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        this.contracts.Art30.deployed().then((instance) => {
          var art30Instance = instance
          this.account = accounts[0]
          console.log(this.account)
          this.$JSEncrypt.setPublicKey(PUBLIC_KEY)
          var encryptedData = this.$JSEncrypt.encrypt(this.email + ' ' + this.phoneNumber)
          console.log(encryptedData)
          buyArtModal.hide()
          return art30Instance.buy(this.displayName, encryptedData, {from: this.account, value: this.price})
        }).then((result) => {
          console.log(result)
        }).catch((err) => {
          console.log(err.message)
        })
      })
    },
    getProvider () {
      // Checking if Web3 has been injected by the browser (Mist/MetaMask)
      if (typeof web3 !== 'undefined') {
        // Use Mist/MetaMask's provider
        this.web3Provider = web3.currentProvider
        web3 = new Web3(this.web3Provider)
      } else {
        // fallback - use your fallback strategy (local node / hosted node + in-dapp id mgmt / fail)
        this.web3Provider = new Web3.providers.HttpProvider('https://mainnet.infura.io/SstctRGwBqgHBphCa48f')
        window.web3 = new Web3(this.web3Provider)
      }
      this.getContract()
    },
    getContract () {
      var Art30Artifact = require('../../build/contracts/Art30.json')
      this.contracts.Art30 = this.$TruffleContract(Art30Artifact)
      this.contracts.Art30.setProvider(this.web3Provider)
      this.networkCheck()
      this.getAccount()
      this.getPrice()
    },
    networkCheck () {
      web3.version.getNetwork((err, netId) => {
        if (err) {
          console.log(err)
          return
        }
        switch (netId) {
          case '1':
            console.log('This is mainnet')
            break
          case '2':
            console.log('This is the deprecated Morden test network.')
            break
          case '3':
            console.log('This is the ropsten test network.')
            break
          default:
            console.log('This is an unknown network.')
        }
      })
    },
    getPrice () {
      this.contracts.Art30.deployed().then((instance) => {
        var art30Instance = instance
        return art30Instance.price.call()
      }).then((result) => {
        //console.log(result)
        this.price = result.valueOf()
        this.priceEth = web3.fromWei(result, 'ether').valueOf()
        this.leadLine = 'Currently worth ' + this.priceEth + ' ETH'
        setTimeout(this.getPrice, 250)
      }).catch((err) => {
        console.log(err.message)
      })
    },
    getAccount() {
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        if (accounts.length != 0)
        {
          this.account = accounts[0]
          console.log(this.account)
        }
      })
    }
  }
}
</script>


<style scoped>
.on-the-left {
    text-align: left;
}

.padded {
    padding: 0 10pc;
}
</style>


// WEBPACK FOOTER //
// src/components/BuyArt.vue